import { LocalStorageKey } from '../enums/localStorageKey.enum'

export const setDataToLocalStorage = (
  localStorageKey: LocalStorageKey,
  data: unknown
): void => {
  const stringifiedData = JSON.stringify(data)
  localStorage.setItem(localStorageKey, stringifiedData)
}
